<div class="bookmarkPane">
	<div class="markerPaneHolder" [class.hidden]="!showMarkersetPane">
		<sim-marker-set-pane
			[scenarioRecording]="scenarioRecording"
			(addMarker)="addMarker($event)"
			[markerSetPaneShowing]="showMarkersetPane"
			[listenForFKeys]="
				(panelOptions?.isInUndockedState && panelOptions?.isUndockedPanel) ||
				(!panelOptions?.isInUndockedState && !panelOptions?.isUndockedPanel)
			"
		/>
	</div>

	<div class="markerEntries" [class.ascending]="ascending" [class.descending]="!ascending">
		@if (scenarioRecording?.markers?.length === 0 && scenarioRecording?.state !== ScenarioRecordingState.Prepared) {
			<div class="noMarkers">
				<div class="icon">
					<i class="fad fa-comment-alt-edit fa-4x"></i>
				</div>
				<div class="mat-h2">
					{{ T.SHARED_BOOKMARK_PANE_NO_ANNOTATION | translate }}
				</div>
			</div>
		}

		@if (scenarioRecording?.state === ScenarioRecordingState.Prepared) {
			<div class="noMarkers">
				<div class="mat-h2">
					{{ T.SHARED_BOOKMARK_PANE_ANNOTATION_SET_DURING_RECORDING | translate }}
				</div>
			</div>
		}

		<div style="height: 100%" #bookmarkScrollContainer id="scrollerContainer">
			@for (
				marker of scenarioRecording?.markers
					| markerFilter: (onlyFavs ? "favs" : "all") : (activeBookmarkOfUserId ? activeBookmarkOfUserId : null);
				track TrackByMethods.trackByMarkerId(markerIndex, marker);
				let markerIndex = $index
			) {
				<div
					[@fadeIn]
					[style.order]="marker.position"
					[@fadeOut]
					[class.active]="showMarkerActive(markerIndex)"
					[attr.data-position]="marker.position"
					class="holder {{ marker['durationClass'] }}"
					[class.beginDuration-1]="
						marker['durationMarkerLines'] && marker['durationMarkerLines'][0].visible && marker['durationMarkerLines'][0].start
					"
					[class.middleDuration-1]="
						marker['durationMarkerLines'] &&
						marker['durationMarkerLines'][0].visible &&
						!marker['durationMarkerLines'][0].start &&
						!marker['durationMarkerLines'][0].end
					"
					[class.endDuration-1]="
						marker['durationMarkerLines'] && marker['durationMarkerLines'][0].visible && marker['durationMarkerLines'][0].end
					"
					[class.beginDuration-2]="
						marker['durationMarkerLines'] && marker['durationMarkerLines'][1].visible && marker['durationMarkerLines'][1].start
					"
					[class.middleDuration-2]="
						marker['durationMarkerLines'] &&
						marker['durationMarkerLines'][1].visible &&
						!marker['durationMarkerLines'][1].start &&
						!marker['durationMarkerLines'][1].end
					"
					[class.endDuration-2]="
						marker['durationMarkerLines'] && marker['durationMarkerLines'][1].visible && marker['durationMarkerLines'][1].end
					"
					[class.beginDuration-3]="
						marker['durationMarkerLines'] && marker['durationMarkerLines'][2].visible && marker['durationMarkerLines'][2].start
					"
					[class.middleDuration-3]="
						marker['durationMarkerLines'] &&
						marker['durationMarkerLines'][2].visible &&
						!marker['durationMarkerLines'][2].start &&
						!marker['durationMarkerLines'][2].end
					"
					[class.endDuration-3]="
						marker['durationMarkerLines'] && marker['durationMarkerLines'][2].visible && marker['durationMarkerLines'][2].end
					"
					[class.beginDuration-4]="
						marker['durationMarkerLines'] && marker['durationMarkerLines'][3].visible && marker['durationMarkerLines'][3].start
					"
					[class.middleDuration-4]="
						marker['durationMarkerLines'] &&
						marker['durationMarkerLines'][3].visible &&
						!marker['durationMarkerLines'][3].start &&
						!marker['durationMarkerLines'][3].end
					"
					[class.endDuration-4]="
						marker['durationMarkerLines'] && marker['durationMarkerLines'][3].visible && marker['durationMarkerLines'][3].end
					"
					[class.beginDuration-5]="
						marker['durationMarkerLines'] && marker['durationMarkerLines'][4].visible && marker['durationMarkerLines'][4].start
					"
					[class.middleDuration-5]="
						marker['durationMarkerLines'] &&
						marker['durationMarkerLines'][4].visible &&
						!marker['durationMarkerLines'][4].start &&
						!marker['durationMarkerLines'][4].end
					"
					[class.endDuration-5]="
						marker['durationMarkerLines'] && marker['durationMarkerLines'][4].visible && marker['durationMarkerLines'][4].end
					"
					[class.markerIsInEditMode]="markerIdInEditMode === marker.markerId"
					(click)="markerClicked(marker)"
				>
					<div
						class="markerPane clickable noselect"
						[style.background-color]="trainingSessionUserData[marker.userId]?.color"
						[class.active]="showMarkerActive(markerIndex)"
						mat-ripple
						(click)="markerPaneClicked(marker)"
					>
						<div class="paneEntryIcon">
							<div class="paneEntryIconWrapper" [class.customMarker]="marker.icon?.isCustomMarker">
								@if (!marker.icon?.isTextMarker) {
									<img
										[src]="marker.icon?.url"
										[style.filter]="
											scenarioRecording?.state === ScenarioRecordingState.Recording ||
											scenarioRecording?.state === ScenarioRecordingState.Prepared
												? 'invert(1)'
												: 'invert(1)'
										"
										[class.noFilterMarker]="disableFilterForIcon(marker.icon?.name)"
										class="mat-icon"
									/>
								} @else {
									<span class="textMarker">{{ marker.icon?.abbreviation }}</span>
								}
							</div>
						</div>
						<div class="paneEntryContent">
							<mat-form-field
								class="full-width-form noHint"
								color="accent"
								[class.editMode]="markerIdInEditMode === marker.markerId && hasRightsToEditMarker(marker)"
							>
								<textarea
									cdkTextareaAutosize
									[cdkAutosizeMaxRows]="9"
									[readonly]="markerIdInEditMode !== marker.markerId || !hasRightsToEditMarker(marker)"
									[appFocus]="markerIdInEditMode === marker.markerId && hasRightsToEditMarker(marker)"
									(focusin)="setMarkerToEditMode(marker)"
									(blur)="focusOutMarker()"
									(keydown.enter)="setMarkerToEditMode(null)"
									spellcheck="false"
									#textElementRef
									class="markerTextArea"
									autofocus
									[ngModel]="markerIdInEditMode !== marker.markerId ? marker.text : markerEditModeValue"
									(ngModelChange)="markerIdInEditMode !== marker.markerId ? marker.text : (markerEditModeValue = $event)"
									[cdkAutosizeMinRows]="1"
									matInput
								></textarea>
							</mat-form-field>
						</div>
						<div class="durations">
							<span class="duration duration1"></span>
							<span class="duration duration2"></span>
							<span class="duration duration3"></span>
							<span class="duration duration4"></span>
							<span class="duration duration5"></span>
						</div>
						<div class="rightSide" appStopPropagation>
							<div class="favAndPlayMediaBtn">
								@if (
									(isDebriefing || isArchive) &&
									!playerInfo?.info.isTwoScreen &&
									marker.markerType === MarkerType.MediaMarker
								) {
									<button
										color="accent"
										mat-icon-button
										class="playMediaBtn"
										(click)="emitMediaMarkerClicked(marker)"
										[matTooltip]="
											playerInfo?.info?.currentMedia?.isPlaying &&
											playerInfo?.info?.currentMedia?.mediaId === marker['mediaId']
												? 'Stop Media'
												: 'Play Media'
										"
										matTooltipClass="accent"
									>
										<sim-animated-material-icon
											[endIcon]="{
												fontSet: 'fad',
												fontIcon: 'fa-play',
											}"
											[startIcon]="{
												fontSet: 'fad',
												fontIcon: 'fa-pause',
												themeColor: 'accent',
											}"
											[trigger]="
												playerInfo?.info?.currentMedia?.isPlaying &&
												playerInfo?.info?.currentMedia?.mediaId === marker['mediaId']
											"
										/>
									</button>
								}
								<button
									mat-icon-button
									class="favButton"
									[class.favSet]="marker.isFavorited"
									(click)="toggleFavorite(marker)"
									appStopPropagation
									(dblclick)="$event.preventDefault(); $event.stopPropagation()"
								>
									<sim-animated-material-icon
										[trigger]="marker.isFavorited"
										[endIcon]="{
											fontSet: 'fas',
											fontIcon: 'fa-star',
											themeColor: 'white',
										}"
										[startIcon]="{
											fontSet: 'fal',
											fontIcon: 'fa-star',
											themeColor: 'accent',
										}"
									/>
								</button>
								@if (hasRightsToEditMarker(marker) || hasRightsToDeleteMarker(marker)) {
									<button mat-icon-button color="accent" [matMenuTriggerFor]="menu">
										<mat-icon fontSet="far" fontIcon="fa-ellipsis-v" inline />
									</button>
								}
								<mat-menu #menu="matMenu">
									@if (hasRightsToEditMarker(marker)) {
										<button
											mat-menu-item
											class="menueButtonWithFAIcon"
											(click)="toggleMarkerEditMode(marker, textElementRef)"
										>
											<mat-icon inline fontSet="fad" fontIcon="fa-edit" />
											<span>{{ T.SHARED_BOOKMARK_PANE_EDIT | translate }}</span>
										</button>
									}
									@if (hasRightsToDeleteMarker(marker)) {
										<button mat-menu-item class="menueButtonWithFAIcon" (click)="deleteMarker(marker.markerId)">
											<mat-icon inline fontSet="fad" fontIcon="fa-trash" />
											<span>{{ T.SHARED_BOOKMARK_PANE_REMOVE | translate }}</span>
										</button>
									}
								</mat-menu>
							</div>
							<div class="paneEntryTimeStamp">
								<sim-timer-display [relativeTime]="marker.position" [startDate]="scenarioRecording?.start" />
							</div>
						</div>
					</div>
				</div>
			}
		</div>
	</div>
</div>
